import { useState } from 'react';

import { CategoryDTO } from '@gearbelt/global';
import { Button } from '@gearbelt/ui/components';

import PencilIcon from '@/components/icons/pencil';
import { Badge } from '@/components/ui/badge';

import { UpdateWorkspaceDocumentCategories } from './update-workspace-document-category';

function DocumentCategories({
  onCategoriesChange,
  documentCategories,
  disabled = false,
}: {
  onCategoriesChange: (documentCategories: CategoryDTO[]) => void;
  documentCategories: CategoryDTO[] | undefined;
  disabled?: boolean;
}) {
  const [openDocumentCategoriesUpdate, setOpenDocumentCategoriesUpdate] = useState(false);

  return (
    <div className="flex w-full items-start gap-4">
      {/* The design's 350px label column includes the 20px gap to the content, so the label itself is 330px */}
      <p className="text-default-text w-[330px] shrink-0 text-sm">Documents categories</p>
      <div className="flex min-w-px flex-1 flex-col gap-2">
        {documentCategories && documentCategories.length > 0 ? (
          <div className="flex flex-wrap gap-1">
            {documentCategories.map((documentCategory) => (
              <Badge key={documentCategory.id} variant="violet" size="sm">
                {documentCategory.name}
              </Badge>
            ))}
          </div>
        ) : (
          <div className="text-secondary-text text-sm">No document categories have been created yet.</div>
        )}
        {!disabled && (
          <Button
            variant="ghost"
            type="button"
            icon={<PencilIcon />}
            className="bg-grey-1 hover:bg-grey-3 w-fit"
            onClick={() => {
              setOpenDocumentCategoriesUpdate(true);
            }}>
            Edit categories
          </Button>
        )}
      </div>

      <UpdateWorkspaceDocumentCategories
        documentCategories={documentCategories}
        open={openDocumentCategoriesUpdate}
        onOpenChange={setOpenDocumentCategoriesUpdate}
        callback={onCategoriesChange}
      />
    </div>
  );
}

export default DocumentCategories;
